import { normalizeColorKey, TEMPLATE_COLOR_KEYS } from '../../util/participantGroups';

// Resolve CSS variables at runtime so charts follow light/dark theme.
// Recharts needs real color strings — CSS var() in inline styles is not evaluated by SVG attributes.
export function readThemeColors() {
  if (typeof window === 'undefined') return {};
  const styles = getComputedStyle(document.body);
  const get = (name) => styles.getPropertyValue(name).trim();
  return {
    text:          get('--text-primary'),
    textSecondary: get('--text-secondary'),
    accent:        get('--accent-color'),
    positive:      get('--positive-color'),
    negative:      get('--negative-color'),
    warning:       get('--warning-color'),
    border:        get('--border-color'),
    borderMuted:   get('--border-muted'),
    bg:            get('--bg-elevated'),
    bgSurface:     get('--bg-surface'),
    group: [
      get('--group-color-1'),
      get('--group-color-2'),
      get('--group-color-3'),
      get('--group-color-4'),
      get('--group-color-5'),
      get('--group-color-6'),
      get('--group-color-7'),
      get('--group-color-8'),
      get('--group-color-9'),
    ].filter(Boolean),
    // Participant group palette (ColorKey → --participant-group-color-<key>), see participantGroupColor().
    participantGroup: Object.fromEntries(
      TEMPLATE_COLOR_KEYS.map(key => [key, get(`--participant-group-color-${key}`)])
    ),
  };
}

// Chart color of a participant group's ColorKey; unknown keys fall back to "neutral" like the dot.
export function participantGroupColor(colors, colorKey) {
  const palette = colors?.participantGroup ?? {};
  return palette[normalizeColorKey(colorKey)] || palette.neutral || colors?.textSecondary;
}
